export { default } from "./LinkBase";
